import { SvgWrap } from 'components/svg'
import { Badges } from 'components/elements'
import Toggle from 'components/toggle'
import { ForwardedRef, ReactNode, forwardRef } from 'react'
import { FieldValues, UseFormRegister } from 'react-hook-form'
import { CSS } from 'theme'

interface ToggleFieldProps {
  register: UseFormRegister<FieldValues> | any
  name: string
  forwardedRef?: ForwardedRef<HTMLInputElement>
  mainHeading: string
  subHeading: string
  value?: boolean
  css?: CSS
  toggleSize?: 'sm' | 'md'
  asCircleIcon?: boolean
  icon?: ReactNode
  checked?: boolean
  disabled?: boolean
}

export const ToggleField = forwardRef<HTMLInputElement, ToggleFieldProps>(
  (props, ref) => {
    const {
      register,
      name,
      mainHeading,
      subHeading,
      value,
      toggleSize,
      css,
      asCircleIcon,
      icon,
    } = props

    return (
      <>
        <Badges
          css={{ ...css }}
          asField={Boolean(value) ? 'primary' : 'secondary'}
          icon={
            <>
              {asCircleIcon ? (
                <>{icon}</>
              ) : (
                <SvgWrap
                  size="xs"
                  css={{
                    p: '$space$8',
                    mr: '$space$16',
                  }}
                  background={'primary'}
                  //   radius={'sm'}
                >
                  {icon}
                </SvgWrap>
              )}
            </>
          }
          asCircleIcon={asCircleIcon}
          button={{
            optionalItem: (
              <Toggle
                {...register(name)}
                size={toggleSize}
                checked={value}
                disabled={props.disabled}
              />
            ),
          }}
          label={{
            mainHeading: {
              text: mainHeading,
            },
            subHeading: {
              text: subHeading,
            },

            labelColumn: true,
          }}
        />
      </>
    )
  }
)
